let result;
let linkHasChecked=[];
function getElementPath(el){
	let path=el.tagName.toLowerCase();
	if(el.id){
		path+='#'+el.id
	}
	if(el.classList.length){
		path+='.'+[].join.call(el.classList,'.')
	}
	let parent=el.parentElement;
	if(parent.tagName!=='BODY'){
		path=getElementPath(parent)+'>'+path
	}
	return path;
}
export default _.debounce(function(){
		// 测试环境
		if(/66buy\.com\.cn/.test(location.href)){
			// URL包含scpcheck=true
			if(/scpcheck/.test(location.href)){
				let allLink=$('a');
				_.each(allLink,item=>{
					let path=getElementPath(item);
					let _if=!_.get(item,'dataset.scp')
						&&_.findIndex(linkHasChecked,item=>item.path==path)==-1
						&&/[a-zA-z]+:\/\/[^\s]+/.test(item.href)
						&&path!=='a#scrollToTop'
					if(_if){
						$(item).css({
							display:'block',
							border:'2px solid black'
						})
						linkHasChecked.push({path,item})
					}
				})
				if(linkHasChecked.length){
					console.log(linkHasChecked)
				}
			}
		}
	},
	500
)